"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.issue = void 0;
const big_js_1 = __importDefault(require("big.js"));
const __1 = require("..");
const collateral_1 = require("../parachain/collateral");
const issue_1 = require("../parachain/issue");
const treasury_1 = require("../parachain/treasury");
function issue(api, electrsAPI, bitcoinCoreClient, issuingAccount, amount, vaultAddress, autoExecute = true, triggerRefund = false, network = "regtest") {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const treasuryAPI = new treasury_1.DefaultTreasuryAPI(api);
            const bitcoinjsNetwork = __1.getBitcoinNetwork(network);
            const issueAPI = new issue_1.DefaultIssueAPI(api, bitcoinjsNetwork, electrsAPI);
            const collateralAPI = new collateral_1.DefaultCollateralAPI(api);
            issueAPI.setAccount(issuingAccount);
            const requesterAccountId = api.createType("AccountId", issuingAccount.address);
            const initialBalanceDOT = yield collateralAPI.balance(requesterAccountId);
            const initialBalancePolkaBTC = yield treasuryAPI.balance(requesterAccountId);
            const blocksToMine = 3;
            const vaultAccountId = vaultAddress ? api.createType("AccountId", vaultAddress) : undefined;
            // request issue
            const requestResult = yield issueAPI.request(amount, vaultAccountId);
            const issueRequest = yield issueAPI.getRequestById(requestResult.id);
            let amountAsBtc = new big_js_1.default(__1.satToBTC(issueRequest.amount.add(issueRequest.fee).toString()));
            if (triggerRefund) {
                // Send 1 more Btc than needed
                amountAsBtc = amountAsBtc.add(1);
            }
            // send btc tx
            const vaultBtcAddress = requestResult.issueRequest.btc_address;
            if (vaultBtcAddress === undefined) {
                throw new Error("Undefined vault address returned from RequestIssue");
            }
            const txData = yield bitcoinCoreClient.sendBtcTxAndMine(vaultBtcAddress, amountAsBtc, blocksToMine);
            if (autoExecute === false) {
                // execute issue, assuming the selected vault has the `--no-issue-execution` flag enabled
                yield issueAPI.execute(requestResult.id.toString(), txData.txid);
            }
            else {
                // wait for vault to execute issue
                while (!(yield issueAPI.getRequestById(requestResult.id)).status.isCompleted) {
                    yield sleep(1000);
                }
            }
            const [finalBalancePolkaBTC, finalBalanceDOT] = yield Promise.all([
                treasuryAPI.balance(requesterAccountId),
                collateralAPI.balance(requesterAccountId)
            ]);
            return {
                request: requestResult,
                initialDotBalance: initialBalanceDOT,
                finalDotBalance: finalBalanceDOT,
                initialPolkaBtcBalance: initialBalancePolkaBTC,
                finalPolkaBtcBalance: finalBalancePolkaBTC,
            };
        }
        catch (e) {
            // IssueCompleted errors occur when multiple vaults attempt to execute the same request
            console.log(e);
            throw new Error(`Issuing failed: ${e.message}`);
        }
    });
}
exports.issue = issue;
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=issue.js.map